import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import {Frame, Grupo, ProgramacionBundleResponse} from '../../providers/models';
import {ItemComponent} from '../item/item.component';
import {Api} from '../../providers/api';
import {Auth} from '../../providers/auth';
import {EntitlementService} from '../../providers/entitlement.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {ActivatedRoute, Router} from '@angular/router';
import {types, etiquetas} from '../../providers/data';
import * as moment from 'moment';

@Component({
  selector: 'app-programacion',
  templateUrl: './programacion.component.html',
  styleUrls: ['./programacion.component.css'],
  providers: [ItemComponent]
})
export class ProgramacionComponent implements OnInit, OnDestroy {

  static gruposFull: Grupo[] = null;

  name: string;
  grupoSelected = null;
  grupos: Grupo[] = null;

  programacion_pantalla;
  otros_frames;
  contenidos;
  publicidades;
  programados;

  programacion_zocalos;
  otros_zocalos;
  zocalos;
  noticias;
  frames_equipos;

  show_modal_file = false;
  show_modal_frame = false;
  show_frame_view = false;
  show_confirm_modal = false;
  confirmMensaje = '';
  framePendiente: any = null;

  cambios = false;

  deletes = [];
  circuito = {id: 0};

  newFrame = {
    nombre: '',
    path: 'null',
    segundos: 0,
    idMedia: 0,
    idTipo: 0,
    bytes: 0,
    idCircuito: 0
  };

  equipos = equipos;
  equipoSelected = equipos[0];

  etiquetas = etiquetas;
  etiquetaSelected = etiquetas[0];
  todosGrupo = {id: 0, nombre: 'Todos'};
  // EQUIPO "todos" placeholder for breadcrumb seg3 (id 0 = nav-only, same semantics as the entry built in requestProgramacion)
  todosEquipo = {id: 0, nombre: 'todos'};

  time_publicidad = '0s';
  time_contenido = '0s';
  time_programacion = '0s';

  titulo = '';
  frameView: any = {};

  paramsSub: Subscription;

  // Entitlement gate (contratos-congelados Slice D2): ZOCALO rail only.
  // PANTALLA COMPLETA rail is intentionally ungated (no flag maps to it).
  zocalosAllowed$: Observable<boolean>;

  constructor(config: NgbDropdownConfig, private spinner: NgxSpinnerService,
              private api: Api, private auth: Auth, private route: ActivatedRoute,
              private router: Router, private entitlement: EntitlementService) {
    // customize default values of dropdowns used by this component tree
    config.autoClose = true;
    config.placement = 'bottom';
    this.zocalosAllowed$ = this.entitlement.hasFeature$('zocalos');
    console.log('init');
  }

  ngOnInit() {
    this.paramsSub = this.route.paramMap.subscribe(params => {
      this.id_grupo = params.get('grupo');
      this.id_equipo = params.get('equipo');
      this.getProgramacionByParam(this.id_grupo, this.id_equipo);
    });
  }

  ngOnDestroy() {
    if (this.paramsSub) {
      this.paramsSub.unsubscribe();
    }
  }

  id_grupo = null;
  id_equipo = null;


  init() {
    this.cambios = false;
    this.equipos = [];
    this.publicidades = [];
    this.contenidos = [];
    this.noticias = [];
    this.zocalos = [];
    this.programacion_zocalos = [];
    this.programacion_pantalla = [];
    this.programados = [];
    this.otros_frames = [];
    this.frames_equipos = [];
  }

  getProgramacionByParam(grupo = null, equipo = null) {
    console.log(grupo, equipo);
    this.cambios = false;
    this.init();
    this.spinner.show();
    this.auth.userCheck(() => {
      this.circuito = this.auth.circuito;
      let req: Observable<ProgramacionBundleResponse>;
      let fullCall = true;
      if (equipo) {
        req = this.api.getProgramacionbyGrupo(grupo);
        fullCall = false;
      } else if (grupo) {
        req = this.api.getProgramacionbyGrupo(grupo);
        fullCall = false;
      } else {
        req = this.api.getProgramacion();
      }
      this.requestProgramacion(req, fullCall);
      this.spinner.hide();
    }, (err) => {
      this.auth.logout();
      console.log(err);
    });
  }

  requestProgramacion(req: Observable<ProgramacionBundleResponse>, fullCall = true) {
    req.subscribe((res: ProgramacionBundleResponse) => {
      if (res && res.data) {
        console.log(res.data);
        if (fullCall) {
          this.grupos = res.data.grupo;
          ProgramacionComponent.gruposFull = res.data.grupo;
        } else {
          this.grupos = ProgramacionComponent.gruposFull || res.data.grupo;
        }
        this.grupoSelected = this.grupos[0];
        this.frames_equipos = res.data.framePos;
        this.frames_equipos.forEach((frame) => {
          frame.exclusive = true;
        });

        this.contenidos = res.data.framesContenido;
        this.publicidades = res.data.framesPublicidad;
        this.programados = res.data.frameProgramado;
        this.programados.forEach((programado) => {
          this.otros_frames.push(programado);
        });
        this.publicidades.forEach((publicidad) => {
          this.otros_frames.push(publicidad);
        });
        this.contenidos.forEach((contenido) => {
          this.otros_frames.push(contenido);
        });
        // Enrich news-frame items with slot name for display
        this.otros_frames.forEach((item) => {
          if (item.idTipo === 8 && item.path) {
            const match = item.path.match(/_slot(?:_(\d+))?_[a-f0-9]{8}(?=\.[^.]+$)/);
            if (match) {
              item.slot = 'slot' + (match[1] ? ' ' + match[1] : '');
            }
          }
        });
        this.otros_zocalos = res.data.frameNoticia;
        this.zocalos = res.data.frameZocalo;
        this.zocalos.forEach((zocalo) => {
          this.otros_zocalos.push(zocalo);
        });
        this.programacion_zocalos = res.data.zocalo;
        this.programacion_pantalla = res.data.spots;

        // Enrich programacion_pantalla items with slot name for display
        this.programacion_pantalla.forEach((item) => {
          if (item.idTipo === 8 && item.path) {
            const match = item.path.match(/_slot(?:_(\d+))?_[a-f0-9]{8}(?=\.[^.]+$)/);
            if (match) {
              item.slot = 'slot' + (match[1] ? ' ' + match[1] : '');
            }
          }
        });

        this.setProgramacionTimes();
        this.fijarNoticia();
        this.otros_frames.reverse();
        this.otros_zocalos.reverse();
        if (this.id_grupo) {
          this.grupos.forEach((grupo) => {
            if (this.id_grupo === grupo.id.toString()) {
              this.grupoSelected = grupo;
              this.titulo = 'Programacion para grupo: ' + this.grupoSelected.nombre;
            }
          });
        }
        this.titulo = this.id_grupo ? 'Programacion para grupo: ' + this.grupoSelected.nombre : 'Mi Circuito';
        if (this.id_equipo) {
          this.equipos = (res.data.equipo.length === 0) ? [{id: 0, nombre: 'No posee equipos'}] : [{id: 0, nombre: 'Todos'}];
          this.equipoSelected = this.equipos[0];
          res.data.equipo.forEach((equipo) => {
            if (this.id_equipo === equipo.id.toString()) {
              this.equipoSelected = equipo;
              this.titulo = 'Programacion para equipo:' + this.equipoSelected.nombre;
            }
          });
          this.programacion_zocalos.map((item) => {
            item.general = true;
            item.tipo = item.tipo + 'block';
          });
          this.programacion_pantalla.map((item) => {
            item.general = true;
            item.tipo = item.tipo + 'block';
          });
          this.orderProgramacion();
          this.orderProgramacionEquipo(this.programacion_pantalla);
        }
        res.data.equipo.forEach((equipo) => {
          this.equipos.push(equipo);
        });
      } else {
        this.init();
      }
      this.spinner.hide();
    }, err => {
      this.auth.checkError(err);
      this.spinner.hide();
    });
  }

  orderProgramacion() {
    // Tipos que pertenecen al riel PANTALLA COMPLETA (mismos allowedTypes del HTML)
    const fullscreenTypes = types
      .filter((t) => ['publicidad', 'contenido', 'programado', 'news-frame'].includes(t.type))
      .map((t) => t.id);
    this.frames_equipos.filter((frame) => {
      const save = true;
      if (frame.idPos.toString() === this.id_equipo) {
        this.programacion_pantalla = this.programacion_pantalla.filter((item) => {
          return item.id !== frame.id;
        });
        this.otros_frames = this.otros_frames.filter(item => item.id !== frame.id);
        this.programacion_zocalos = this.programacion_zocalos.filter((item) => {
          return item.id !== frame.id;
        });
        this.otros_zocalos = this.otros_zocalos.filter(item => item.id !== frame.id);
        // colocar frame de equipo en programacion
        if (fullscreenTypes.includes(frame.idTipo)) {
          this.programacion_pantalla.push(frame);
        } else {
          this.programacion_zocalos.push(frame);
        }
      }
      return save;
    });
  }

  orderProgramacionEquipo(programacion) {
    const order_list = [];
    console.log(programacion);
    programacion.forEach((frame, index) => {
      if (!frame.general) {
        order_list[frame.posicion - 1] = frame;
        console.log(frame.posicion);
      }
    });
    programacion.forEach((frame) => {
      if (frame.general) {
        let fill = true;
        let i = 0;
        while (fill) {
          if (!order_list[i]) {
            fill = false;
          } else {
            i++;
          }
        }
        order_list[i] = frame;
      }
    });
    console.log(order_list);
    this.programacion_pantalla = order_list.filter((frame) => frame && frame != null);
  }

  selectEtiqueta(etiqueta = null) {
    console.log(etiqueta);
    this.etiquetaSelected = etiqueta;
    this.equipoSelected = null;
    this.router.navigate(['/programacion']);
  }

  selectGrupo(grupo = null) {
    console.log(grupo);
    this.equipoSelected = null;
    if (grupo && grupo.id !== 0) {
      this.grupoSelected = grupo;
      this.titulo = 'Programacion para grupo: ' + grupo.nombre;
      this.router.navigate(['/programacion', grupo.id]);
    } else {
      this.router.navigate(['/programacion']);
    }
  }

  selectEquipo(equipo = null) {
    console.log(equipo);
    if (equipo) {
      this.equipoSelected = equipo;
      this.id_grupo = this.grupoSelected ? this.grupoSelected.id : this.id_grupo;
      if (equipo.id === 0) {
        this.router.navigate(['/programacion', this.id_grupo]);
      } else {
        this.titulo = 'Programacion para equipo: ' + equipo.nombre;
        this.router.navigate(['/programacion', this.id_grupo, this.equipoSelected.id]);
      }
    } else {
      this.equipoSelected = null;
      const id = this.grupoSelected ? this.grupoSelected : null;
    }
  }


  removeFrame(item = null) {

    // se utilza para eliminar los frames
    if (this.deletes && this.deletes.length > 0) {
      console.log('Rmeove frame');
      this.spinner.show();
      this.api.deleteFrame(this.deletes[0].id).subscribe(
        (res: any) => {
          this
            .spinner
            .hide();
        },
        err => {
          console.log(err);
          this.spinner.hide();
        }
      );
      this.deletes = [];
    } else {
      // se utilza para eliminar los frames
      console.log('Insert');
      this.setProgramacionTimes();
    }
    this.fijarNoticia();
  }

  setProgramacionTimes() {
    let _time_publicidad = 0, _time_contenido = 0;
    let _time_actual = 0;
    this.programacion_pantalla.map((item) => {
      _time_actual += item.segundos;
      if (item.tipo === 'contenido') {
        _time_contenido += item.segundos;
      }
      if (item.tipo === 'publicidad') {
        _time_publicidad += item.segundos;
      }
      const format_actual = (_time_actual < 60) ? 'ss' : ((_time_actual < 3600) ? 'mm:ss' : 'HH:mm:ss');
      item.time_actual = moment.utc(_time_actual * 1000).format(format_actual);
    });
    const format_contenido = (_time_contenido < 60) ? 'ss' : ((_time_contenido < 3600) ? 'mm:ss' : 'HH:mm:ss');
    const format_publicidad = (_time_publicidad < 60) ? 'ss' : ((_time_publicidad < 3600) ? 'mm:ss' : 'HH:mm:ss');
    const format_programacion = (_time_actual < 60) ? 'ss' : ((_time_actual < 3600) ? 'mm:ss' : 'HH:mm:ss');
    this.time_contenido = moment.utc(_time_contenido * 1000).format('HH:mm:ss');
    this.time_publicidad = moment.utc(_time_publicidad * 1000).format('HH:mm:ss');
    this.time_programacion = moment.utc(_time_actual * 1000).format('HH:mm:ss');
  }


  insertItem(insert) {
  }

  removeItem(item: any, list: any[]): void {
    list.splice(list.indexOf(item), 1);
    this.removeFrame();
    this.cambios = true;
  }

  fijarNoticia() {
    const aux = [];
    let noticia;
    this.programacion_zocalos.forEach((zocalo) => {
      if (zocalo.idTipo === 4) {
        noticia = zocalo;
      }
    })
    ;
    this.otros_zocalos.forEach((zocalo) => {
      if (zocalo.idTipo === 4) {
        noticia = zocalo;
      } else {
        aux.push(zocalo);
      }
    });
    this.otros_zocalos = [];
    if (noticia) {
      noticia.idrandom = this.getrandom();
      this.otros_zocalos.push(noticia);
    }
    aux.forEach((zocalo) => {
      this.otros_zocalos.push(zocalo);
    });
  }

  getrandom() {
    return Date.now().toString() + Math.random().toString();
  }

  saveProgramacion() {
    if (this.cambios) {
      let programacion = this.updatePositions();
      if (this.id_equipo) {
        programacion = programacion.filter(frame => !frame.general);
      }
      console.log(programacion);
      if (programacion) {
        const body: any = {
          'programacion': programacion
        };
        let req;
        if (this.equipoSelected && this.equipoSelected.id !== 0) {
          body.idPos = this.equipoSelected.id;
          req = this.api.updateProgramacionbyPos(body);
        } else {
          body.idGrupo = this.grupoSelected.id;
          req = this.api.updateProgramacion(body);
        }
        this.spinner.show();
        req.subscribe((res: any) => {
          console.log(res);
          this.spinner.hide();
          this.cambios = false;
        }, err => {
          console.log(err);
          this.spinner.hide();
        });
      }
    }
  }

  updatePositions() {
    let i = 1;
    return this.programacion_pantalla.concat(this.programacion_zocalos).map((frame: Frame) => {
      const copy = Object.assign({}, frame);
      copy.posicion = i;
      copy.idFrame = copy.id;
      copy.desde_fecha = copy.desde_fecha ? copy.desde_fecha : null;
      copy.hasta_fecha = copy.hasta_fecha ? copy.hasta_fecha : null;
      copy.desde_hora = copy.desde_hora ? copy.desde_hora : null;
      copy.hasta_hora = copy.hasta_hora ? copy.hasta_hora : null;
      i = i + 1;
      return copy;
    });
  }

  agregarFrame() {
    this.newFrame = {
      nombre: '', path: 'null', segundos: 0, idMedia: 0, idTipo: 0,
      bytes: 0, idCircuito: this.circuito.id
    };
    this.show_modal_frame = true;
  }

  /** Modal para previsualizar el video y editar**/

  showViewFrame(frame, programacion) {
    console.log('programacion');
    console.log(this.programacion_pantalla);
    console.log(this.frameView);
    console.log(frame);
    this.frameView = Object.assign({}, frame, {programacion: programacion});
    if (this.frameView.idTipo != null) {
      this.frameView.idTipo = Number(this.frameView.idTipo);
    }
    this.show_frame_view = true;
  }

  closeframe() {
    this.frameView = null;
    this.show_frame_view = false;
  }

  /** Agregar Frame Flujo **/

  closeAgregar() {
    this.show_frame_view = false;
    this.show_modal_frame = false;
    this.show_modal_file = false;
  }

  showUploadFile(frame) {
    this.newFrame = frame;
    this.show_modal_frame = false;
    this.show_modal_file = true;
  }

  crearFrame(frame) {
    console.log(frame);
    this.newFrame = frame;
    this.closeAgregar();
    this.spinner.show();
    this.api.addFrame(this.newFrame).subscribe((res: any) => {
      this.spinner.hide();
      this.selectGrupo(this.grupoSelected);
      this.closeAgregar();
    }, err => {
      const msg = err.error && err.error.message ? err.error.message : (err.message || 'Error desconocido');
      console.error('Error al crear frame:', err);
      alert('Error: ' + msg);
      this.spinner.hide();
      this.closeAgregar();
    });
  }

  saveFrame(frame) {
    console.log(frame);
    this.frameView = null;
    this.show_frame_view = false;
    if (frame.programacion) {
      this.programacion_pantalla = this.programacion_pantalla.map((_frame) => {
        if (_frame.id === frame.id) {
          return frame;
        }
        return _frame;
      });
      this.cambios = true;
      this.saveProgramacion();
    } else {
      if (this.cambios) {
        this.framePendiente = frame;
        this.confirmMensaje = 'Tiene cambios sin guardar en la programación de pantalla completa o zócalos. ¿Qué desea hacer?';
        this.show_confirm_modal = true;
        return;
      }
      this.api.editFrame(frame).subscribe((res: any) => {
        console.log('edit frame');
        console.log(res);
        this.selectGrupo(this.grupoSelected);
      }, err => {
        console.log(err);
      });
    }
  }

  onConfirmGuardarTodo() {
    this.show_confirm_modal = false;
    const frame = this.framePendiente;
    this.framePendiente = null;
    this.api.editFrame(frame).subscribe((res: any) => {
      console.log('edit frame');
      console.log(res);
    });
    this.saveProgramacion();
  }

  onConfirmCancelar() {
    this.show_confirm_modal = false;
    this.framePendiente = null;
  }
}

interface FormFrame {
  nombre?;
  path?;
  segundos?;
  idMedia?;
  idTipo?;
  bytes?;
  idCircuito?;
}

export const equipos = [
  {
    id: 0, nombre: 'Equipos del grupo'
  }];






// WEBPACK FOOTER //
// ./src/app/admin/programacion/programacion.component.ts